
/* injects from baggage-loader */

'use strict';

const environment = 'production';

// node_modules
import "angular";
import "@uirouter/angularjs";
import "angular-resource";
import "oclazyload";
import "angular-animate";
import "angular-cookies";
import "angular-touch";
import "angular-sanitize";
import "angular-messages";
import "angular-aria";
import "jquery";
import "angular-resource";
import "ng-file-upload";
import "angular-timeago";
import "angular-scroll";
import "angular-drag-and-drop-lists";

// local scripts
//import "../assets/js/...";

// Setup Sentry
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

// Import sentry if not running local dev env
if (environment !== 'development') {

  // Make sure to call Sentry.init after importing AngularJS. 
  // You can also pass {angular: AngularInstance} to the Integrations.Angular() constructor.
  Sentry.init({
    dsn: 'https://cbd372b0677d4b458436534c4865c409@o281652.ingest.sentry.io/6419703',
    integrations: [
      new Integrations.Angular(),
      // enable capture of console.error events
      new Integrations.CaptureConsole({
        levels: ['error']
    }),
    ],
    
    // release: 1,
    environment: environment,
    // beforeSend: (event, hint) => {
    //   console.log('Event!', event);
    //   return event;
    // }
  });

}


// WEBPACK FOOTER //
// ./src/app/index.vendor.js